<script setup>
import SideNav from '../Components/Navs/SideNav.vue';
// import { ref } from 'vue';
import { Head, router } from '@inertiajs/vue3';
import SgNavbar from '@/Components/Navs/SgNavbar.vue';
import NewFooter from '@/Components/NewFooter.vue';
import PwaInstallPrompt from '@/Components/PwaInstallPrompt.vue';

defineProps({
  user: Object,
  title: String
});
</script>

<template>
  <div class="flex flex-col bg-gray-100 transition-colors duration-300 dark:bg-gray-900 dark:!text-gray-50">

    <Head :title="title" />

    <SgNavbar />


    <div class="flex flex-col flex-1">
      <!-- Page Heading -->
      <header
        v-if="$slots.header"
        class="bg-gray-200 text-gray-900 shadow dark:bg-gray-900 dark:!text-gray-100"
      >
        <div class="px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8 dark:bg-gray-900">
          <slot name="header" />
        </div>
      </header>

      <!-- Page Content -->
      <!-- <main class="min-h-[80vh] flex-grow">
        <slot />
      </main> -->

      <main class="min-h-[80vh] flex-grow bg-white dark:!bg-[#111827]">
        <div class="flex flex-row max-w-6xl mx-auto">
          <SideNav class="hidden md:block md:w-1/5" />
          <div class="w-full md:w-4/5">
            <slot />
          </div>
        </div>
      </main>
    </div>
    <NewFooter />
    <PwaInstallPrompt />
  </div>
</template>
